module.exports = __webpack_public_path__ + "static/media/hall-P8.69e8084c.svg";